var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _path9, _rect4, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9399,
    y: 7.02734,
    width: 16.3454,
    height: 18.9723,
    fill: "url(#pattern0_886_38676)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6557 7.09961H12.4967C12.0433 7.09961 11.6758 7.46715 11.6758 7.92053V23.822C11.6758 24.2754 12.0433 24.6429 12.4967 24.6429H25.6557C26.1091 24.6429 26.4766 24.2754 26.4766 23.822V7.92053C26.4766 7.46715 26.1091 7.09961 25.6557 7.09961Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.323,
    y: 6.82617,
    width: 15.6157,
    height: 18.2426,
    fill: "url(#pattern1_886_38676)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6556 7.09961H12.4966C12.0432 7.09961 11.6757 7.46715 11.6757 7.92053V23.822C11.6757 24.2754 12.0432 24.6429 12.4966 24.6429H25.6556C26.109 24.6429 26.4765 24.2754 26.4765 23.822V7.92053C26.4765 7.46715 26.109 7.09961 25.6556 7.09961Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3498 7.10156H12.4966C12.3891 7.10156 12.2826 7.12284 12.1834 7.16416C12.0841 7.20549 11.994 7.26606 11.9183 7.34237C11.8425 7.41868 11.7826 7.50922 11.7421 7.60879C11.7015 7.70835 11.681 7.81496 11.6818 7.92248V11.4859H19.3498V7.10156Z",
    fill: "#21A366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6678 7.10156H19.3497V11.4859H26.4704V7.92248C26.4721 7.70741 26.3886 7.50042 26.2382 7.34664C26.0879 7.19286 25.8828 7.10477 25.6678 7.10156Z",
    fill: "#33C481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4765 15.8691H19.3497V20.2535H26.4765V15.8691Z",
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3498 20.2535V15.8691H11.6818V23.8168C11.681 23.9249 11.7017 24.032 11.7426 24.132C11.7836 24.2319 11.844 24.3227 11.9204 24.3991C11.9968 24.4755 12.0876 24.536 12.1876 24.5769C12.2876 24.6179 12.3947 24.6386 12.5027 24.6378H25.6678C25.7758 24.6386 25.8829 24.6179 25.9829 24.5769C26.0829 24.536 26.1737 24.4755 26.2501 24.3991C26.3265 24.3227 26.3869 24.2319 26.4279 24.132C26.4688 24.032 26.4895 23.9249 26.4887 23.8168V20.2535H19.3498Z",
    fill: "#185C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3498 11.4844H11.6758V15.8687H19.3498V11.4844Z",
    fill: "#107C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4765 11.4844H19.3497V15.8687H26.4765V11.4844Z",
    fill: "#21A366"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33337,
    y: 9.88867,
    width: 13.8644,
    height: 13.7185,
    fill: "url(#pattern2_886_38676)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3336 10.9414H8.1062C7.65282 10.9414 7.28528 11.3089 7.28528 11.7623V19.9897C7.28528 20.4431 7.65282 20.8107 8.1062 20.8107H16.3336C16.787 20.8107 17.1545 20.4431 17.1545 19.9897V11.7623C17.1545 11.3089 16.787 10.9414 16.3336 10.9414Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.95093,
    y: 10.7754,
    width: 10.6537,
    height: 10.5078,
    fill: "url(#pattern3_886_38676)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3337 10.9395H8.10632C7.65294 10.9395 7.2854 11.307 7.2854 11.7604V19.9878C7.2854 20.4412 7.65294 20.8087 8.10632 20.8087H16.3337C16.7871 20.8087 17.1547 20.4412 17.1547 19.9878V11.7604C17.1547 11.307 16.7871 10.9395 16.3337 10.9395Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3336 10.9375H8.1062C7.65282 10.9375 7.28528 11.305 7.28528 11.7584V19.9858C7.28528 20.4392 7.65282 20.8068 8.1062 20.8068H16.3336C16.787 20.8068 17.1545 20.4392 17.1545 19.9858V11.7584C17.1545 11.305 16.787 10.9375 16.3336 10.9375Z",
    fill: "#107C41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85754 18.5382L11.5663 15.8687L9.97916 13.1992H11.2561L12.1196 14.9019C12.1987 15.06 12.2534 15.1816 12.2838 15.2606C12.3385 15.1329 12.3994 15.0052 12.4602 14.8836L13.3845 13.1992H14.5581L12.9405 15.8687L14.6067 18.5626H13.3905L12.3872 16.6957C12.3416 16.6161 12.3029 16.5327 12.2717 16.4464C12.2426 16.5316 12.2038 16.6133 12.1561 16.6896L11.0737 18.5382H9.85754Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5,
    d: "M16.3336 10.9375H8.1062C7.65282 10.9375 7.28528 11.305 7.28528 11.7584V19.9858C7.28528 20.4392 7.65282 20.8068 8.1062 20.8068H16.3336C16.787 20.8068 17.1545 20.4392 17.1545 19.9858V11.7584C17.1545 11.305 16.787 10.9375 16.3336 10.9375Z",
    fill: "url(#paint0_linear_886_38676)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_886_38676",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_886_38676",
    transform: "scale(0.00884956 0.00763359)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_886_38676",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_886_38676",
    transform: "scale(0.00925926 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_886_38676",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_886_38676",
    transform: "scale(0.0104167 0.0105263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_886_38676",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_886_38676",
    transform: "scale(0.0135135 0.0136986)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_886_38676",
    x1: 9.00009,
    y1: 10.2929,
    x2: 15.4397,
    y2: 21.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_886_38676",
    width: 113,
    height: 131,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACDCAYAAAC6JPTCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD0ElEQVR4Xu3YTU8TURiG4fsUbIsf+BWJGnXBwhh3/v8fYmKMGGPUGEXkS6jOHBfvOe1UxrKxRZ48d3JS6ExZcPGemSHlnHGXu/XzTgBIKaX65cIT3b8uA+RzJi0tOl7wBmWtlVdDrqYMtEBTXtu/YfYiFrxETOoQGJc1IjANudwygXcKnJQ1AX4RgzmHdgaxM31D4BpwE7gL3AGul/c9kcurTuAEOAR2ga/AHnBc3p+byrlrYgdwTODdBx4DT4AHwO1ybA23zBpi+r4BH4B3ZX0E9okJ7UckpmsIbBJ4z8raJkA3iS11gFtmLQG1T8C9JnZFiC21SSn9rNM4RSxTuAZsAFvAU+AF8Bx4xGwK1/FWuuwygXVCXMqul/ePgAMCuCnrzCQOmCFuE5Db5QdtMLtDdcuvJX7nw/L9AfCprO/AaUqpzTnnLmKdxBGxbW6VdQu4ClzBE7jK6qPdNWKIHpZ1h7hOHhLTemaq6mPFiICrfwl+rLiY6vP5mBis28ANZvclqZ70Z3Ui/YD/fzRgNlhjeoZq0fXNcP9P3f+cnRkq36RcrnoHy4gCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGfFylfveXITY+wF3IWWg7aw5mz7EDDTl5Ppq0Iup4v0CToGT8trQMVnv+VD9wDHwA5gAo3I84VZZS/z+j4A9YBc4JHymw9VFrBN4CuwDn8u6WY4P8TV0ldWBOgI+Au+A98BXYriaeuKfk9iWEz4Db5gBbgEbwBpuVbXEQO0RgC+BHeALsa22Oef5Scw555RSwwzxVTn0nUC8ihFXWUNg7RITuAO8JVAnBDIAqWDGNyklYsscA5sE3j1iIkflmK+Ly6/e0EyAAwLyCwF4DPzMOfcjwhzkkNhCNwjAdQy4yuo1cULsjifl66YLCD2IMIVMxPY5KK8GXH11Iuuj3vQ62K0XcXowMMGAF1mGuGf52wkLEd3l6DfHVuwii6DFdAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_886_38676",
    width: 108,
    height: 126,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAB+CAYAAADBePRdAAAACXBIWXMAAC4jAAAuIwF4pT92AAACb0lEQVR4Xu3XzXHaUBhG4XMJSxtKIAWkhbiANOAC0lN6SAMU4GxcAAVACYC38ZeFJFvDzzKId+acjcTVZfXMJy6tqjittTY7W7SbVVXv1561MVhrrQELYAU8AO3K9+z/VMAbsAOOl+A+wHqsJfAdeKZDE+y2FR3WGtgA26o6jDe0qhpjPQE/++sCm6IjsAVegV/AZjxp8/66oJusAWuJ0zVVS+Bbf/9CN3H74eGsP2Cs6F6DYt1HX4CvwA9gNT4EDjePdGgLxLqXBpPH8eL4+C7U/XVm4v+tsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLawxWV3fZVJ2ZDGBHYAccLm2ySRpMjuPFWVW99w9+Ay/AHtGm7i+wBdbArjcCYN5fD8AfoPWfn4AFNkVHOqxXYMPJhM0Bqqpaa3u6Cat+04pPQLtNRfe2W9NhbcfTBdCqPt9+rbVGN1kr4AHBbl0Bb/S/XadYcAL2sdiax/0JuwQ1dBHM7rd/jp90H8g9bqAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_886_38676",
    width: 96,
    height: 95,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_886_38676",
    width: 74,
    height: 73,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABJCAYAAACaRLDfAAAACXBIWXMAAC4jAAAuIwF4pT92AAABy0lEQVR4Xu3cMVLCUBSF4f8ylKI7EHvXoDuwdwOuTXtXIKyB3rgDwZpncfMMJOCcmnf+hglkmMk3ScoTpRRqERHAAlgCV0DQRgX4ATpgVw5R+qJ+1yNdA4/AM4nVElQHvAErYDvGmsME6QV46I9b6p58mgBWEXGENe8/FwxIjyRSK3dT7Ya89toHsK0H84iYkY/ZM8Od1BoS5DVfkwY74DMiNqWUPcCsP6m+wFtFqlWsJcNjCAxQ9SSXTSwOodw/GUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlK7BBqMi7VcBOLCrUjh6a2p05qqEIadKTJX7N+9qeuca2Bb2A//ocG2pPXviYtujqJBMPQ1o6cLIPcervnxDTQBVefqA3wSloc3VHjjbsFcEdCPQG3XP5cUgG+gHcS6pMTg4AxOqZfKFuQSC0sJ9bFxC8S6ORrZwL190OCNdM5oNpZKHfcL4k/bZY4tSNlAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.94cf779316d8e382bd8663a3f8742c47.svg";
export { ForwardRef as ReactComponent };